import React from 'react';
import CrossRoad from "../UI/Crossroad";

const CrossRoad5HBlack5KBlue = () => <CrossRoad coords="1621.000000, 501.000000"/>;
export default CrossRoad5HBlack5KBlue;
